<template>
  <div>
    <span class="back">
      <!-- <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.7071 5.79289C16.0976 6.18342 16.0976 6.81658 15.7071 7.20711L10.4142 12.5L15.7071 17.7929C16.0976 18.1834 16.0976 18.8166 15.7071 19.2071C15.3166 19.5976 14.6834 19.5976 14.2929 19.2071L8.29289 13.2071C7.90237 12.8166 7.90237 12.1834 8.29289 11.7929L14.2929 5.79289C14.6834 5.40237 15.3166 5.40237 15.7071 5.79289Z"
          fill="black"
        />
      </svg> -->
      Attestation d’assurance Automobile
    </span>

    <form @submit.prevent="saveAndPrint" class="box">
      <div class="h-10">Informations</div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Nom & Prénom de l’assurée</label>
            <input v-model="form.full_name" type="text" class="form-control" disabled />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Adresse de l’assurée</label>
            <input v-model="form.address" type="text" class="form-control" readonly />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>Profession</label>
            <input
              v-model="form.professsion"
              type="text"
              class="form-control"
              readonly
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>Police N°</label>
            <input v-model="form.num_police" type="text" class="form-control" disabled />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Du</label>
            <input v-model="form.du" type="date" class="form-control" disabled />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Au</label>
            <input v-model="form.au" type="date" class="form-control" disabled />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>Vehicule ( Marques)</label>
            <input
              list="marques"
              v-model="form.marque"
              type="text"
              class="form-control"
              disabled
            />
          </div>
        </div>
        <datalist id="marques">
          <option
            v-for="(item, key) in payment.marques"
            :key="key"
            :value="item.name"
          ></option>
        </datalist>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>Immatriculation</label>
            <input
              v-model="form.immatriculation"
              type="text"
              class="form-control"
              disabled
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>N° Châssis</label>
            <input
              v-model="form.num_chassis"
              type="text"
              class="form-control"
              disabled
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Genre</label>
            <input type="text" v-model="form.genre" class="form-control" disabled />
          </div>
        </div>
      </div>
      <div class="row" v-if="payment.type_engin == '1'">
        <div class="col-md-12">
          <div class="form-group">
            <label>Catégorie d’usage</label>
            <select v-model="form.category" class="form-control" disabled>
              <option selected :value="payment.category.id">
                {{ payment.category.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <hr />
      <div class="p-t">Remorque / Semi-Remorque / Appareil Terreste</div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Mono</label>
            <input v-model="form.type" type="text" class="form-control" disabled />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Marque</label>
            <input
              list="marques"
              v-model="form.semi_marque"
              type="text"
              class="form-control"
              disabled
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>Immatriculation</label>
            <input
              v-model="form.semi_immatriculation"
              type="text"
              class="form-control"
              disabled
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="float-right">
            <button v-if="loading" disabled class="btn btn-primary">
              Sauvegarder & Imprimer
            </button>
            <button v-else type="submit" class="btn btn-primary">
              Sauvegarder & Imprimer
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import { api } from "../../../../helpers/shared";
export default {
  name: "assAuto",
  props: {
    content: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    loading: false,
    payment: {},
    form: {
      full_name: "",
      address: "",
      professsion: "",
      num_police: "",
      du: "",
      au: "",
      marque: "",
      immatriculation: "",
      num_chassis: "",
      genre: "",
      category: "",
      address_assureur: "",
      type: "",
      semi_marque: "",
      semi_immatriculation: "",
    },
  }),
  created() {
    this.payment = JSON.parse(this.content);
  },
  mounted() {
    console.log(this.payment)
    // if (Object.entries(this.payment.data).length > 0) {
    //   this.form = { ...this.payment.data };
    // }
    this.form.full_name =
    this.payment.subscription.client_name + " " + this.payment.subscription.client_firstname;
    
    this.form.address_assureur = this.settings.address_nsia || 'Rue Brazza derrière la grande poste';

    if (this.payment.user.address !== null) {
      this.form.address = this.payment.user.address;
    }
    if (this.payment.type_engin == "1") {
      this.form.category = this.payment.category.id;
    }
    if (Object.keys(this.payment.other).length > 0){
      this.form.num_police = this.payment.other.num_police;
      this.form.marque = this.payment.other.marque;
      this.form.immatriculation = this.payment.other.immatriculation;
      this.form.semi_immatriculation = this.payment.other.immatriculation;
      this.form.type = this.payment.other.type;
      this.form.du = this.payment.other.date_effet;
      this.form.au = this.payment.other.date_expiration;
      this.form.num_chassis = this.payment.other.serie
      this.form.semi_marque = this.payment.other.marque;
      this.form.genre = this.payment.other.genre;
      this.form.address = this.payment.other.address_client;
      this.form.professsion = this.payment.other.activity;
    }
  },
  methods: {
    saveAndPrint() {
      this.loading = true;
      axios
        .post(
          api("administration/contract/" + this.payment.uuid + "/auto"),
          this.form,
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", this.payment.uuid + ".pdf");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          this.loading = false;

          location.href = `/administration/contract/${this.payment.uuid}/cima`
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.back {
  //cursor: pointer;
  color: #5e5873;
  font-size: 20px;
  margin-bottom: 20px;
  display: inline-block;
}
.box {
  width: 80%;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 4px;
  min-height: 100px;
  height: auto;
  padding: 10px;
}
.h-10 {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 20px;
}
.mtk-row {
  display: flex;
  flex-direction: row;
  gap: 20px;
}
hr {
  opacity: 0.8;
}
.p-t {
  margin-bottom: 20px;
  font-weight: bold;
  font-size: 18px;
}
</style>
